import React from 'react';
import PropTypes from 'prop-types';
import './Strip.scss';
import { getImageUrl } from '../../../config';

const Strip = ({ images }) => {
	if (!images) return;

	return (
		<div className="titles-strip">
			{images.map((image, i) => (
				<picture key={`${image.src.jpg}-${i}`}>
					{image.src.avif && <source srcSet={getImageUrl(image.src.avif)} type="image/avif" />}
					{image.src.jpg && (
						<img decoding="async" loading="lazy" src={getImageUrl(image.src.jpg)} alt={image.alt} />
					)}
				</picture>
			))}
		</div>
	);
};

Strip.propTypes = {
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.shape({
				jpg: PropTypes.string,
				avif: PropTypes.string,
			}),
			alt: PropTypes.string,
		})
	),
};

export default Strip;
